<template>
  <div class="custom-multiple operation-item">
    <block-title title="自定义模板信息">
      <template #icon-right>
        <a-button
          v-track-click="{ trackName: '批量导入下单-新建模板' }"
          class="create-btn-plus"
          type="primary"
          @click="addTemplate"
        >
          <a-icon type="plus" />
          新建模板
        </a-button>
      </template>
      <div class="item-content widthStyle">
        <a-form-model
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 19 }"
        >
          <a-form-model-item
            label="模板名称"
            :colon="false"
          >
            <a-select
              v-model="form.templateCode"
              :options="templateList"
              @change="changeTemplate"
            >
            </a-select>
          </a-form-model-item>
        </a-form-model>
        <div v-if="form.templateCode&&form.fileUrl" class="template-info">
          <div class="template-info-name">
            <img src="@/assets/img/icon/icon_xlsx.png" />
            <span>{{form.fileName}}</span>
          </div>
          <img
            class="template-info-download"
            src="@/assets/img/icon/icon_download.png"
            @click="downTemplate"
          />
        </div>
      </div>
    </block-title>
    <block-title v-if="isCustomerFillInContractCode&&isNeedTransport" title="合同条款">
      <div  class="template-contract item-content ">
        <div class="widthStyle template-info">
          <div>
            <img src="@/assets/img/icon/icon_hetong.png" />
            <span>{{form.contractName}} - {{form.contractTermName}}</span>
          </div>
        </div>
        <a class="change-contract" @click="replaceContract">更换合同条款</a>
      </div>
    </block-title>
    <select-contract
      ref="SelectContract"
      :contract-list="transportContract"
      :default-contract-code="form.contractCode"
      :default-term-code="form.contractTermCode"
      @success="successContract"
    />
  </div>
</template>

<script>
import BlockTitle from '@/components/panel/BlockTitle.vue'
import SelectContract from './SelectContract.vue'
import {customerTemplateDetail} from '../api'

export default {
  name: 'CustomMultiple',
  components: {
    BlockTitle,
    SelectContract,
    // SelectProduct,
  },
  props: {
    templateList: {
      type: Array,
      default: () => []
    }, // 自定义导入模板
    productList: { // 标准产品
      type: Array,
      default: () => []
    },
    form: {
      type: Object,
      default: () => {}
    },
    transportContract: { // 非标合同
      type: Array,
      default: () => []
    },
    isCustomerFillInContractCode:{ // 
      type:Boolean,
      default:true,
    }
  },
  data() {
    return {
      isNeedTransport:false, // 是否需要运输
    }
  },
  methods: {
    // 切换模板
    changeTemplate(val) {
      if (val) {
        const current = this.templateList.filter(item => item.templateCode === val)[0]
        this.form.templateCode = current?.templateCode
        this.form.fileName = current?.fileName;
        this.form.fileUrl = current?.fileUrl;
        this.getTemplateDetail(current?.templateCode)
      }else{
        this.form.templateCode = undefined
        this.form.fileName = undefined;
        this.form.fileUrl = undefined;
      }
    },
    async getTemplateDetail(templateCode){
      const res = await customerTemplateDetail({templateCode});
      if(res.businessType==="TRANSPORT_ONLY"){
        this.isNeedTransport = true;
      } else{
        this.isNeedTransport = res?.others?.defaultNeedTransport||false;
      }
    },
    addTemplate() {
      this.$router.push('/createTemplate')
    },
    downTemplate() {
      const { fileName,fileUrl } = this.form;
      const x = new XMLHttpRequest();
      x.open('GET', fileUrl, true);
      x.responseType = 'blob';
      x.onload = () => {
        const csvUrl = window.URL.createObjectURL(x.response);
        const link = document.createElement('a');
        link.href = csvUrl;
        link.download = fileName;
        link.click();
      };
      x.send();
    },
    replaceContract() {
      this.$refs.SelectContract.show()
    },
    replaceProduct(){
      this.$refs.SelectProduct.show()
    },
    successContract(data) {
      this.form.contractCode = data.contractCode
      this.form.contractTermCode = data.contractTermCode
      this.$set(this.form,'contractName', data.contractName)
      this.$set(this.form,'contractTermName', data.contractTermName)
      this.$emit('changeContract',data)
    },
    successProduct(data){
      this.$set(this.form,'product', data.product)
      this.$set(this.form,'productName', data.productName)
    },
    
  }
}
</script>

<style lang="less" scoped>
.custom-multiple {
  .create-btn-plus {
    margin: 0 32px 0 12px;
    background: linear-gradient(244deg, #06B889 0%, #24D69E 100%);
    border-radius: 4px;
    font-weight: 500;
    color: #FFFFFF;
    height: 40px;
    padding: 0 16px;
    line-height: 40px;
    border: none;
  }
  .template-info {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #F2FBF8;
    padding: 0 16px;
    border-radius: 4px;
    .template-info-name {
      img {
        width: 46px;
        height: 46px;
      }
    }
    span {
      color: #171717;
      margin-left: 16px;
    }
    .template-info-download {
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
  }
  .template-contract {
    display: flex;
    align-items: center;
    img {
      width: 32px;
      height: 32px;
    }
    .change-contract {
      margin-left: 24px;
    }
  }
}
</style>